import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { useUser } from "@/contexts/user-provider";
import { PERMISSIONS, hasPermission } from "@/lib/permissions";
import { ChatStatus } from "@/types/enums/chat";
import { useUpdateChatStatusMutation } from "@/query/comms/chat";
interface UseMarkChatReadOnOpenOptions {
  chatId: string | null | undefined;
  /** The loaded chat detail; the effect waits for it before marking read. */
  chat: {
    id: string;
    status: ChatStatus;
  } | null | undefined;
}

/**
 * Marks a chat READ the first time it is shown, when the person viewing it has
 * turned on "Mark Chats as Read When Opened" in their Preferences. Read state is
 * shared, so it clears for the whole clinic. Only on open: a message that
 * arrives while the chat is already on screen still flips it UNREAD, as it
 * would for anyone else.
 * Skipped for staff who can't change a chat's status (the route would 403).
 */
export function useMarkChatReadOnOpen(t0) {
  const $ = _c(13);
  const {
    chatId,
    chat
  } = t0;
  const {
    currentUser
  } = useUser();
  const {
    mutate: updateChatStatus
  } = useUpdateChatStatusMutation();
  const handledChatIdRef = useRef(null);
  let t1;
  if ($[0] !== currentUser) {
    t1 = (currentUser?.markChatReadOnOpen ?? false) && hasPermission(currentUser, PERMISSIONS.MESSAGING_CHATS_WRITE);
    $[0] = currentUser;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const enabled = t1;
  let t2;
  if ($[2] !== chat || $[3] !== chatId || $[4] !== enabled || $[5] !== updateChatStatus) {
    t2 = () => {
      if (!enabled || !chatId || chat?.id !== chatId) {
        return;
      }
      if (handledChatIdRef.current === chatId) {
        return;
      }
      handledChatIdRef.current = chatId;
      if (chat.status === ChatStatus.UNREAD) {
        updateChatStatus({
          chatId,
          status: ChatStatus.READ
        });
      }
    };
    $[2] = chat;
    $[3] = chatId;
    $[4] = enabled;
    $[5] = updateChatStatus;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = chat?.id;
  const t4 = chat?.status;
  let t5;
  if ($[7] !== chatId || $[8] !== enabled || $[9] !== t3 || $[10] !== t4 || $[11] !== updateChatStatus) {
    t5 = [enabled, chatId, t3, t4, updateChatStatus];
    $[7] = chatId;
    $[8] = enabled;
    $[9] = t3;
    $[10] = t4;
    $[11] = updateChatStatus;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  useEffect(t2, t5);
}